import { p as promiseResolve, b as bootstrapLazy } from "./index-6a8d4a1b.js";

var patchEsm = function patchEsm() {
  return promiseResolve();
};

var defineCustomElements = function defineCustomElements(o, e) {
  if (typeof window === "undefined") return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["img-comparison-slider", [[1, "img-comparison-slider", null, [[0, "keydown", "onKeyDown"], [0, "keyup", "onKeyUp"], [1, "mousedown", "onMouseDown"], [9, "mouseup", "onMouseUp"], [1, "touchstart", "onTouchStart"], [0, "touchmove", "onTouchMove"], [1, "touchend", "touchEnd"], [0, "blur", "onBlur"], [0, "focus", "onFocus"], [9, "resize", "updateAfterWidth"]]]]]], e);
  });
};

export { defineCustomElements };